import { LOBs } from "./quote-step.model";

export class SaveEventModel {
  Status: string;
  LOBs: LOBs[];
}
